import * as backend from '@/api/backend';
import { checkResponseStatus } from '@/util/check';

export default {
  state: {
    templates: [],
    loading: false,
    error: false,
  },
  mutations: {
    fetch(state) {
      state.loading = true;
    },
    errorTemplates(state) {
      state.templates = [];
      state.loading = false;
      state.error = true;
    },
    setTemplates(state, templates) {
      state.templates = templates;
      state.loading = false;
      state.error = false;
    },
  },
  getters: {
    activeTemplates: (state) => state.templates.filter((t) => t.active !== false),
  },
  actions: {
    async fetchTemplates({ commit }, { onlyActive = true } = {}) {
      commit('fetch');
      try {
        const response = await backend.getDealTemplates(onlyActive);
        await checkResponseStatus(200, response);
        commit('setTemplates', response.data);
      } catch (error) {
        console.error(error);
        commit('errorTemplates');
      }
    },
    async createTemplate(context, { template }) {
      const response = await backend.postDealTemplate(template);
      await checkResponseStatus(200, response);
      return response.data;
    },
    async updateTemplate(context, { templateId, template }) {
      const response = await backend.putDealTemplate(templateId, template);
      await checkResponseStatus(200, response);
      return response.data;
    },
    async deleteTemplate(context, { templateId }) {
      const response = await backend.deleteDealTemplate(templateId);
      await checkResponseStatus(204, response);
    },
  },
  namespaced: true,
};
